module.exports = __webpack_public_path__ + "img/it_iron_2019_web_badge.0e77f9a0.png";